import React from 'react'

import classes from './Form.scss'

import InputGroup from '../../../../../../components/UI/Forms/InputGroup/InputGroup'

const form = ({ form, inputChanged, formulaSelectChanged, isValueGetZero }) => {
    const forms = Object.entries(form).map(item => {
        let [formKey, formAttrs] = item
        if (formKey === 'value_get_zero' && !isValueGetZero) {
            return null
        }
        return (
            <InputGroup
                key={formKey}
                label={formAttrs.label}
                variant={'modal'}
                inputType={formAttrs.elementType}
                configs={formAttrs.elementConfig}
                invalid={!formAttrs.valid}
                validations={formAttrs.validation}
                touched={formAttrs.touched}
                changed={e => inputChanged(formKey, e)}
                formulaSelectValue={formAttrs.formulaSelectValue}
                selectValueChanged={e => formulaSelectChanged(formKey, e)}
                inputValue={formAttrs.value}
                validationError={formAttrs.error}
            />
        )
    })

    return <div className={classes.Form}>{forms}</div>
}

export default form
